import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11 5v8h8","key":"svg-0"}],["path",{"d":"M7 9v8h8","key":"svg-1"}]]

/**
 * IconChevronsDownLeft
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY2hldnJvbnMtZG93bi1sZWZ0Igo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xMSA1djhoOCIgLz4KICA8cGF0aCBkPSJNNyA5djhoOCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/chevrons-down-left
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconChevronsDownLeft = createReactComponent('outline', 'chevrons-down-left', 'ChevronsDownLeft', __iconNode);

export default IconChevronsDownLeft;